import { AppStrings } from '../messages';

export const Italian: AppStrings = {
    or: ' o ',
    max: 'massimo',
    accept: 'Accetta',
    submit: 'Invia',
    back: 'Indietro',
    purchase: 'Acquista',
    no_thanks: 'No, grazie',
    thank_you: 'Grazie!',
    cancel: 'Cancella',
    close: 'Chiudi',
    click_here_to_get_code: 'Clicca qui per ottenere il tuo codice',
    open: 'Open',
    option_unavailable: 'Al momento non è disponibile',
    confirm: 'Confermare',

    my_trip: 'Il mio viaggio',
    finalize_trip: 'Completa il tuo viaggio',
    trip_all_set: 'Il tuo viaggio è pronto',
    trip_overview_capitalized: 'Panoramica del Viaggio',
    manage_guests_capitalized: 'Invita Ospiti',
    manage_guests_title: 'Invita ospiti',
    manage_pets_title: 'Aggiungi/Rimuovi Cani',
    manage_pets_error:
        'Spiacenti, si è verificato un errore. Per parlare con un rappresentante del servizio clienti, chiama il numero 1-800-544-0300',
    instructions_for_modify_guests:
        'Facci sapere quanti adulti, bambini (oltre i 2 anni) soggiorneranno. Se i tuoi piani non sono ancora stati finalizzati, aggiungi gli ospiti che conosci per ora: puoi tornare e aggiornare queste informazioni in un secondo momento.',
    instructions_for_modify_guests_pets:
        'Facci sapere quanti adulti, bambini (oltre i 2 anni e cani soggiorneranno). Se i tuoi piani non sono ancora stati finalizzati, aggiungi gli ospiti che conosci per ora: puoi tornare e aggiornare queste informazioni in un secondo momento.',
    instructions_for_modify_pets: 'Amico peloso e code scodinzolanti sono i benvenuti. Aggiungi fino a {pets} cani al tuo soggiorno.',
    instructions_for_modify_pet: 'Amico peloso e code scodinzolanti sono i benvenuti. Aggiungi fino a 1 cane al tuo soggiorno.',
    extra_instructions_for_modify_pet: 'Hai cambiato idea? Ti rimborseremo le spese per animali pagate entro 5 giorni lavorativi.',
    max_occupancy_modify_guests:
        'Massimo l´occupazione è di {max_occupancy} {guests}. Potrebbero essere applicati costi aggiuntivi che verranno mostrati di seguito.',
    add_remove_guest: 'Aggiungi o Rimuovi Ospite',
    modify_your_trip: 'Modifica il tuo viaggio',
    getting_there: 'Come arrivare',
    in_the_home: 'In casa',
    checkout_instructions: 'Istruzioni per il check out',
    codes_will_be_provided: 'I codici saranno forniti 1 settimana prima della data del check in',
    passwords_will_be_provided: 'La password sarà fornita 1 settimana prima della data del check in',
    alarm_code: 'Codice allarme',
    lockbox_code: 'Codice cassetta di sicurezza',
    e_lock_codes: 'Codici e-Lock',
    gate_access: 'accesso al cancello',
    stay_longer: 'Resta qualche giorno in più',
    location_and_parking: 'Posizione e parcheggio',
    on_your_way: 'In viaggio',
    directions_to_know: 'Indicazioni da sapere',
    directions_and_parking_notes: 'Indicazioni stradali & informazioni sul parcheggio',
    parking_spaces: 'Parcheggi',
    parking_notes: 'Note sul parcheggio',
    entering_home: 'Per entrare in casa',
    home_access_details: 'Informazioni per l’accesso in casa',
    house_rules: 'Regole della casa',
    internet_access: 'Accesso a internet',
    network: 'Rete',
    password: 'Password',
    reservation: 'Prenotazione',
    trip_overview: 'Panoramica del viaggio',
    nights: 'Notti',
    max_occupancy: 'Capienza massima',
    can_add_guest: 'Puoi aggiungere fino a {total} altri {guests}',
    can_not_add_guest: 'Hai raggiunto il numero massimo di invitati',
    guest: 'Ospite',
    guests: 'Ospiti',
    confirmation: 'Conferma',
    view_listing: 'Visualizza annuncio',

    rental_agreement: 'Accordo di locazione',
    sign_agreement: 'Firma accordo',
    sign_by: 'Rivedere e firmare {signBy}',
    sign_agreement_by: 'Si prega di firmare le informazioni sull’accordo di locazione entro il  {signBy}',
    signed_on: 'Firmato il {signedOn}',
    i_agree_terms: 'Accetto i termini e le condizioni di cui sopra',
    agreed_on: 'Hai accettato i termini il {agreedOn}',
    i_agree_new_terms: `Accetto il <a  target="_blank" rel="noopener noreferrer" href="{rental_agreement_url}">Contratto di Noleggio</a> di Vacasa, <a  target="_blank" rel="noopener noreferrer" href="{privacy_policy_url}">Politica sulla Privacy</a>, e `,
    agreed_new_terms_on: `Hai accettato il <a  target="_blank" rel="noopener noreferrer" href="{rental_agreement_url}">Contratto di Noleggio</a> di Vacasa, <a   target="_blank" rel="noopener noreferrer" href="{privacy_policy_url}">Politica sulla Privacy</a>, e `,
    agreed_new_terms_on_date: ` il {date}`,
    unit_terms_text: `Termini Specifici dell'Unità`,
    unit_terms_alert: `A meno che non sia indicato diversamente nel `,
    new_terms_required_text: `Richiesto`,
    new_terms_instructions_text: `Rivedi le regole della casa e conferma l'accordo sottostante`,
    new_terms_submit_btn: `Invia`,
    view_agreement: 'Visualizza accordo',
    print_header_text:
        'Si prega di seguire queste istruzioni. Riceverai una notifica una volta che avremo ricevuto ed elaborato il tuo accordo',
    print_step_one: 'Stampa, rivedi e firma questo accordo',
    print_step_two: 'Invia a noi via e-mail o fax',
    print_button: 'Stampare',
    print_email_label: 'Email',
    print_fax_label: 'Fax',
    print_email_value: 'info@vacasa.com',
    print_fax_value: '(503) 897-7036',
    print_booked_by: 'Prenotato da',
    print_on: 'su',

    payment_details: 'Dettagli pagamento',
    make_payment: 'Effettua un pagamento',
    pay_balance: 'Paga Saldo',
    balance_due: 'Saldo dovuto',
    payment_complete: 'Pagamento completato',
    pay_by: '{total} in scadenza entro {payBy}',
    pay_balance_by: 'Paga il tuo saldo entro il {payBy}',
    view_receipt: 'Visualizza ricevuta',
    original_payment: 'Pagamento originale',

    refund_going_to: 'Rimborso in corso a',
    original_payment_methods: 'Metodi di pagamento originali',
    guest_paid: 'Ospite pagato {amount} in {data}',
    refund_details: 'Dettagli sul rimborso',
    total_refund: 'Rimborso totale',

    cancellation_charges: 'Spese di cancellazione',
    sure_you_want_to_cancel: 'Sei sicuro di voler cancellare il tuo viaggio?',
    yes_cancel_now: 'Sì, annulla ora.',
    no_dont_cancel: 'No, non annullare.',
    cancel_trip: 'Annulla viaggio',
    cancel_and_receive_refund: 'Annulla e ricevi rimborso',
    view_cancellation_policy: 'Visualizza la politica di cancellazione',

    balance_in: 'Saldo in {currency}',
    total_in: 'Totale in {currency}',
    new_balance_due: 'Nuovo saldo in {currency}',
    processed_in_currency_notice: 'La transazione è stata processata in {currency}. I tassi di conversione sono soggetti a variazioni.',

    vehicle_registration: 'Registrazione del veicolo',
    vehicle: 'Veicolo',
    list_your_vehicles: 'I veicoli del tuo gruppo',
    register_vehicle: 'Registra veicolo',
    max_vehicles_reached: 'È stato raggiunto il numero massimo di veicoli',
    group_has_no_vehicles: 'Il mio gruppo non ha veicoli',
    register_by: 'Aggiungi tutti i veicoli entro il {registerBy}',
    register_vehicles_by: 'Si prega di registrare i veicoli entro il {registerBy}',
    add_vehicle_info: 'Aggiungi le informazioni sul veicolo',
    add_a_vehicle_button: 'Aggiungi veicolo',
    add_vehicle_title: 'Aggiungi un veicolo',
    add_vehicle_text: 'Aggiungi un veicolo al tuo viaggio.',
    vehicle_added: 'Informazioni sul veicolo aggiunte',
    edit_a_vehicle_button: 'Salvare le Modifiche',
    edit_vehicle_title: 'Modifica un veicolo',
    edit_vehicle_text: 'Modifica le informazioni sul veicolo.',
    remove_vehicle_text: 'Elimina un veicolo dal tuo viaggio..',
    remove_vehicle_title: 'Elimina un veicolo',
    remove_vehicle_button: 'Rimuovere',
    my_group_has_no_vehicles_title: 'Il mio gruppo non ha veicoli',
    my_group_has_no_vehicles_confirm_text:
        'Potresti essere multato dalla città o dall´HOA se il tuo gruppo porta un veicolo senza registrarlo in anticipo.',
    my_group_has_no_vehicles_confirm_button: 'Conferma nessun veicolo',
    license_plate: 'Targa',
    state_province: 'Stato / Provincia',
    other: 'Altro',
    location: 'Posizione',

    add_on: 'In aggiunta',
    pool_heat: 'Riscaldamento piscina',
    pool_heat_added: 'Riscaldamento piscina aggiunto',
    pool_heat_note:
        'Aggiorna il tuo soggiorno con il nostro supplemento di climatizzazione della piscina! Tuffati nel comfort e nel calore ad ogni nuotata.',

    finalize_your_reservation: 'Concludi la tua prenotazione',
    these_actions_are_required: 'È necessario completare queste azioni per ottenere i dettagli del check-in.',

    need_help: 'Ti serve aiuto?',
    visit_our: 'Visita la nostra ',
    support_center: 'Centro di supporto',
    still_have_questions: 'Hai altre domande?',
    please_reach: 'Contattaci: ',

    home_essentials: 'Informazioni essenziali sulla casa',
    no_beds: 'Niente letti',
    king_bed: 'letto matrimoniale',
    king_bed_plural: 'letti matrimoniali',
    queen_bed: 'letto matrimoniale',
    queen_bed_plural: 'letti matrimoniali',
    double_bed: 'letto matrimoniale',
    double_bed_plural: 'letti matrimoniali',
    twin_bed: 'letto matrimoniale',
    twin_bed_plural: 'letti gemelli',
    child_bed: 'letto bambino',
    child_bed_plural: 'letti per bambini',
    murphy_bed: 'letto a scomparsa',
    murphy_bed_plural: 'letti a scomparsa',

    no_bathrooms: 'Num. begni',
    full_bath: 'bagno completo',
    full_bath_plural: 'bagni completi',
    half_bath: 'mezzo bagno',
    half_bath_plural: 'mezzi bagni',

    sleeps: 'Posti letto',

    loading: 'Caricamento',
    updated_successfully: 'Aggiornato correttamente',
    read_more: '...Più informazioni',
    read_less: '… Meno informazioni',

    who_is_coming: 'Chi sta arrivando',
    invite_guest: 'Invita ospite',
    invite_guest_note:
        'Gli ospiti invitati riceveranno un’email con le informazioni relative al check in {daysBefore} giorni prima del viaggio.',
    invite_guest_note_same_day: "Gli ospiti invitati riceveranno un'e-mail di check-in dettagliata il giorno dell'arrivo",
    add_guest: 'Invita un ospite',
    edit_guest: 'Modifica ospite',
    remove_guest: 'Elimina ospite',
    edit_guest_note_modal: 'Modifica gli ospiti per condividere le informazioni di viaggio relative a percorso e accesso.',
    invite_guest_info: 'Aggiungi informazioni sull’ospite',
    email_addresses_guests: 'Indirizzo email',
    modify_guest_note: 'Puoi aggiungere o eliminare gli ospiti dal tuo viaggio.',
    modify_guest_add_note: 'Puoi aggiungere fino a {remainingGuests} ulteriori ospiti',
    need_cancel_trip: 'Devi cancellare il viaggio?',
    need_cancel_note: 'Se devi cancellare il viaggio, ti invitiamo a leggere le condizioni qui.',
    cancel_trip_options: 'Vedi le opzioni di cancellazione',
    name: 'Nome',
    first_name: 'Nome',
    last_name: 'Cognome',
    email_address: 'Indirizzo email',
    invite_guest_note_modal: 'Aggiungi gli ospiti per condividere le informazioni di viaggio relative a percorso e accesso.',
    yes_remove_invited: 'Sì',
    no_remove_invited: 'Non importa',
    can_add_pet: 'Aggiungi fino a {total} amico peloso',
    can_add_pets: 'Aggiungi fino a {total} amici pelosi',
    can_not_add_pet: 'Hai raggiunto il numero massimo di cani',
    add_pet_refund_btn: 'Recevoir un remboursement',
    add_pet_update_balance_title: 'Mettre à jour le solde',
    add_pet_checkout_title: 'Continuer le paiement',
    pet: 'Cane',
    pets: 'Cani',
    remove_invite_note: 'sarà rimosso dalla lista degli ospiti',
    are_you_sure: 'Sei sicuro?',

    cookie_disclaimer: 'Vacasa utilizza cookie proprietari o di terze parti. Utilizzando i nostri siti, accetti la nostra Cookie Policy.',
    read_cookie_policy: 'Leggi la nostra Cookie Policy',
    sitemap: 'Mappa del sito',
    privacy: 'Privacy',
    terms_of_service: 'Termini del servizio',

    property_management: 'Gestione Delle case Vacanze',
    real_estate: 'Immobiliare',
    innovation: 'Innovazione',
    company: 'Azienda',
    about_us: 'Chi siamo',
    blog: 'Blog',
    careers: 'Opportunità di carriera',
    newsroom: 'Sala stampa',
    investors: 'Investitori',
    community: 'Comunità',
    social_responsibility: 'Responsabilità sociale',
    leadership: 'Comando',
    solutions_partnerships: 'Soluzioni e partnership',
    accessibility: 'Accessibilità',
    help: 'Aiuto',
    covid_update: 'COVID-19 Updates',
    support_contact: 'Assistenza e contatti',
    toll_free: 'Numero Verde:',
    local: 'Locale:',
    hi: 'Salve, ',
    my_trips: 'I miei viaggi',
    favorites: 'Preferiti',
    profile: 'Profilo',
    logout: 'Esci',
    owner_login: 'Accesso Proprietario',
    owner_portal: 'Account Proprietario',
    login: 'Accesso / Registrazione Ospite',
    find_my_trip: 'Trova il mio viaggio',
    my_account: 'Accedi / Registrati',
    language_and_currency: 'Lingua',

    somethings_not_right: 'Si è verificato un errore',
    an_error_occurred: "Si è verificato un errore durante l'elaborazione della richiesta",
    try_later_or_call: 'Ti invitiamo a riprovare più tardi oppure chiama il tuo rappresentante Vacasa al numero',
    identity_check_required: 'Per continuare è necessario verificare l’identità',
    verify_identity: 'Verifica la tua identità',

    something_went_wrong: 'Uh oh, qualcosa è andato storto',
    error_cancelling: "Si è verificato un errore durante l'annullamento della prenotazione.",
    contact_customer_service: 'Contatta il servizio clienti al {phone} per ulteriore assistenza',

    already_completed_idv: `L'hai già completato?`,
    click_here: 'Clicca qui',

    guest_portal_unavailable: 'Trip Manager non è disponibile',
    resolve_issues_calling: 'Per risolvere il problema, chiama il tuo rappresentante Vacasa al numero',

    session_expired: 'Sessione scaduta',
    session_expired_message: 'La sessione è scaduta. Stai per essere reindirizzato a',

    access_token_expired: 'Session expirée',
    access_token_expired_message: 'La sessione è scaduta. Verrai reindirizzato per aggiornare la sessione.',

    getting_there_capitalized: 'Come arrivare',
    modify_your_trip_capitalized: 'Modifica il tuo viaggio',
    checkout_instructions_capitalized: 'Istruzioni per il check out',

    trip_eligibility_trip_already_started:
        'Evviva, il tuo viaggio è iniziato! Se desideri modificare ulteriormente il tuo viaggio, ti invitiamo a chiamare un rappresentante Vacasa per gli ospiti al numero',
    trip_eligibility_pending_payment: 'Il tuo pagamento è in fase di elaborazione. Controlla tra 24 ore per modificare il tuo viaggio.',
    trip_eligibility_created_before_june_fourth_2018:
        'Se desideri modificare ulteriormente il tuo viaggio, ti invitiamo a chiamare un rappresentante Vacasa per gli ospiti al numero',
    trip_eligibility_negative_balance: 'Il tuo rimborso è in corso. Controlla tra 24 ore per modificare il tuo viaggio.',
    trip_eligibility_not_allowed_for_occupancy: 'Siamo spiacenti, ma non è possibile modificare ospiti/cani per questa prenotazione.',
    trip_eligibility_refund_in_progress:
        'Hai un rimborso in corso. Attendi fino a quando non viene elaborato per modificare la tua occupazione',

    wheres_my_receipt: 'Dov’è la ricevuta della mia prenotazione?',
    channel_receipt_note:
        'Hai effettuato la tua prenotazione tramite uno dei nostri partner di prenotazione. Ti preghiamo di contattare l\'azienda con cui hai prenotato per accedere alla tua ricevuta e alle informazioni di pagamento.',
    download_app_mobile_note: 'Easy check-in',
    download_app_mobile_title: 'Join us on the app!',

    payment_title: 'Effettua un pagamento',
    receipt_title: 'Ricevuta',
    addons_title: 'Componenti aggiuntivi di viaggio',
    latecheckout_title: 'Aggiungi check-out posticipato',
    modify_trip_title: 'Modifica viaggio',

    pool_heat_add_or_remove: 'Aggiungi o rimuovi il calore della piscina',

    submit_guest_edition: 'Invia edizione ospite',
    confirm_guest_remove: 'Conferma rimuovi ospite',

    ready_to_checkout: 'Pronto per il checkout?',
    note_early_checkout:
        'Fai clic per confermare che stai effettuando il checkout. Questo avviserà anche il nostro team delle pulizie che sei partito.',
    checkout_now: 'Controlla ora',
    not_ready_yet: 'Non sono ancora pronto',
    all_set: 'Tutto stabilito!',
    note_confirm_early_checkout: 'Grazie, il check-out è completo. Speriamo di ospitarti di nuovo presto!',
    got_it: 'Nessun problema',
    note_cancel_early_cehckout:
        'Puoi effettuare il check-out entro le {checkout}. Quando sei pronto, fai di nuovo clic sul link di check-out nel messaggio di testo che ti abbiamo inviato.',

    rent: 'Affittare',
    fees: 'Tariffe',
    taxes: 'Tassazione',
    trip_protection: 'Protezione viaggio',
    not_purchased: 'Non acquistato',
    previous_balance: 'Saldo precedente',
    sub_total: 'totale parziale',
    pet_refund: 'Rimborso cane',
    adult_added: 'Adulto aggiunto',
    adults_added: 'Adulti aggiunti',
    pet_added: 'Cane aggiunto',
    pets_added: 'Cani aggiunti',
    child_added: 'Bambino aggiunto',
    children_added: 'Bambini aggiunti',

    payment_processed_by: 'Pagamento elaborato da:',
    billing_address: 'Indirizzo Di Fatturazione:',

    view_receipt_capitalized: 'Siehe Quittung',

    receipt_thirty_party_channel: 'Grazie per aver prenotato la tua casa Vacasa tramite {channel}',

    covid19_text: 'An update on coronavirus (COVID-19) and our cancellation policies',
    covid19_button_text: 'Read Our Latest Updates',
    covid19_link: 'https://www.vacasa.com/support/coronavirus-covid-19',

    square_feet: 'piedi quadrati',

    browser_deprecated: 'Browser non supportato',
    please_upgrade_browser: 'Aggiorna o utilizza un altro browser per visualizzare questo sito',

    know_before_you_go: 'Sapere prima di andare',
    import_details: 'Dettagli importanti',
    directions_and_parking_details: 'Indicazioni e dettagli sul parcheggio',
    note_for_our_guests: 'Note per i nostri ospiti',

    cannot_perform_action_title: 'Questa pagina non è al momento disponibile',
    cannot_perform_action_message: 'Ti invitiamo a riprovare più tardi oppure chiama il tuo rappresentante Vacasa al numero',

    fsc_credits: 'Future Stay Credits',

    address: 'Indirizzo',
    features_and_amenities: 'Caratteristiche e servizi',
    features_and_amenities_capitalized: 'Caratteristiche e Servizi',

    cancel_trip_title: 'Annulla il tuo viaggio',

    payment_form_add_night: 'Aggiungi una notte',
    payment_form_add_night_note: 'Il tuo nuovo orario di check-out sarà',
    payment_form_pricing_details: 'Dettagli sui prezzi',
    payment_form_pricing_discounted_rent: 'Affitto scontato',
    payment_form_pricing_discount: 'Sconto',
    payment_form_total: 'Totale',
    payment_form_billing_information: 'Informazioni di fatturazione',
    payment_form_billing_name: 'Nome fatturazione',
    payment_form_country: 'Nazione',
    payment_form_city: 'Città',
    payment_form_island: 'Isola',
    payment_form_postal_code: 'Codice Postale',
    payment_form_province: 'Provincia',
    payment_form_city_or_town: 'Città/Paese',
    payment_form_region: 'Regione',
    payment_form_county: 'contea',
    payment_form_department: 'Dipartimento',
    payment_form_governorate: 'Governatorato',
    payment_form_state: 'Stato',
    payment_form_area: 'Zona',
    payment_form_parish: 'Parrocchia',
    payment_form_prefecture: 'Préfecture',
    payment_form_emirate: 'Emirat',
    payment_form_zip_code: 'Cap',
    payment_form_card_number: 'Numero di carta',
    payment_form_expiration_date: 'Data di scadenza',
    payment_form_expiration_month: 'Mese di scadenza',
    payment_form_expiration_year: 'Anno di scadenza',
    payment_form_security_code: 'Codice di sicurezza',
    payment_form_payments_note: 'Accettiamo la maggior parte delle principali carte di credito',
    payment_form_pay_now: 'Paga ora',
    payment_form_visa: 'Visa',
    payment_form_master_card: 'Master',
    payment_form_discover: 'Discover',
    payment_form_reservation_details: 'Dettagli della prenotazione',
    payment_form_adult: 'Adulto',
    payment_form_adults: 'Adulti',
    payment_form_child: 'Bambino',
    payment_form_children: 'Bambini',
    payment_form_month: 'Mese',
    payment_form_year: 'Anno',
    payment_successful: 'Tutto stabilito!',
    payment_successful_note:
        "Goditi quella notte di vacanza in più. Di seguito troverai i dettagli del pagamento e controlla la tua posta in arrivo per un'e-mail di conferma con le nuove date del viaggio.",
    payment_failed: 'Non è stato possibile elaborare il pagamento',
    payment_call_us_to_complete: 'Non preoccuparti, per ora ti riserviamo la notte extra.',
    payment_call_us_to_complete_start: 'Chiama',
    payment_call_us_to_complete_end: 'per pagare tramite telefono e confermare la modifica al tuo viaggio.',
    payment_form_removed: 'Rimossa',
    payment_form_added: 'Aggiunto',
    payment_successful_generic_note: 'Il tuo viaggio è aggiornato. Ecco la conferma del pagamento.',
    payment_trip_paid_in_full: 'Il tuo viaggio è pagato per intero.',
    payment_successful_add_pet_adjustment_note:
        'Hai aggiunto {total} {pet} al tuo soggiorno. Lascia iniziare il movimento della coda. Ecco la tua conferma di pagamento',
    payment_successful_add_pet_adjustment_refund_note:
        'Hai rimosso {total} {pet} dal tuo soggiorno. Ti rimborseremo tutte le tasse per animali domestici pagate entro 5 giorni lavorativi.',
    payment_successful_add_pool_heat_adjustment_note:
        'Hai aggiunto il riscaldamento della piscina al tuo soggiorno. Ecco la conferma del pagamento.',

    modal_adjustment_not_available_continue: 'Continua',
    modal_adjustment_not_available_back_to_trip: 'Torna ai dettagli del viaggio',
    modal_adjustment_not_available_title: 'Questa notte non è più disponibile',
    modal_adjustment_not_available_note_start:
        "Spiacenti, non possiamo aggiungere la notte extra al tuo viaggio. (Un altro ospite ha già prenotato o l'offerta è scaduta.)",
    modal_adjustment_not_available_note_end: 'Ci auguriamo che tu abbia comunque un ottimo soggiorno!',

    modal_adjustment_pending_balance_title: 'Paga il tuo saldo per sbloccare questo accordo',
    modal_adjustment_pending_balance_note_start: 'Prima di aggiungere una notte, dovrai pagare il saldo corrente per il tuo viaggio.',
    modal_adjustment_pending_balance_note_end: 'Dopo aver pagato, puoi tornare alla tua email e riprovare.',

    modal_lco_adjustment_not_available_title: 'Check-out tardivo non disponibile',
    modal_lco_adjustment_not_available_note_start: `Spiacenti, non possiamo aggiungere il checkout tardivo al tuo soggiorno.`,
    modal_lco_adjustment_pending_balance_note_start:
        'Prima di aggiungere il checkout tardivo, dovrai pagare il saldo attuale del tuo viaggio.',

    night_added: 'notte aggiunta',
    nights_added: 'notti aggiunte',

    maintenance_window_title: 'This page is under maintenance',
    maintenance_window_note: 'We will be live again very soon. Thanks for you patience',
    maintenance_go_to_home: 'Go to Homepage',
    maintenance_link: 'https://www.vacasa.com',

    modal_cancel_go_to_my_trips: 'Go to My Trips',
    modal_cancel_title: 'Canceled reservation',
    modal_cancel_note: 'Your reservation has been successfully canceled',

    billing_information_note: 'Si prega di rivedere le modifiche e confermare per completare gli aggiornamenti di viaggio.',

    adjustment_failed_title: 'Non siamo riusciti a modificare il tuo viaggio',

    whats_nearby: "Cosa C'è Nelle Vicinanze",
    whats_nearby_capitalized: "Cosa c'è nelle Vicinanze",
    checkout_best_of_city:
        'Scopri il meglio di {unitCity} mentre sei qui. Esplora i ristoranti, le attrazioni e molto altro nei dintorni di {unitName}.',
    banking: 'Banca',
    restaurants_and_coffee: 'Ristoranti e caffè',
    groceries: 'Drogheria',
    hospitals: 'Ospedali',
    movie_theaters: 'Cinema',
    bars_and_nightlife: 'Bar e vita notturna',
    parks: 'Parchi',
    pharmacies: 'Farmacie',
    shopping: 'Acquisti',
    sports: 'Sport',
    universities: 'Università',
    tourist_attractions: 'Attrazioni turistiche',
    filter_by_category: 'Filtrer par catégorie',

    star_rating_title: 'Rivedi il tuo soggiorno',
    star_rating_note: "Com'è stata la tua esperienza presso {unitName}? Il tuo feedback è importante per noi.",
    next: 'Prossimo',

    pay_balance_issue: 'Chiama {phone} per pagare e confermare la modifica al tuo viaggio.',

    chat_default_message: 'Ciao, come possiamo aiutarti oggi?',
    chat_default_name: 'Vacasa Customer Service',
    chat_start_new_button: 'Avvia nuova chat',
    chat_start_content: 'Grazie per aver chattato con noi!',
    chat_open: 'La chat dal vivo è disponibile',
    chat_message_close:
        'Purtroppo ci hai raggiunto al di fuori degli orari della chat dal vivo. Per assistenza immediata si prega di chiamare la nostra linea di supporto 24 ore su 24.',
    chat_rule_close: '{openTime} alle {closeTime}.',
    chat_rule: 'tutti i giorni dalle {openTime} alle {closeTime}.',
    chat_error: 'Errore durante l`inizializzazione della chat',
    chat_loading: 'loading...',
    chat_me: 'Me',

    extended_stay_capitalized: 'Estende il mio Soggiorno',
    extended_stay_rules: 'Seleziona fino a 4 notti aggiuntive prima o dopo il viaggio programmato per prolungare il soggiorno.',
    extended_stay_success_alert_plural: '<b>{numberNights} notti</b> aggiunte al tuo itinerario per <b>{price}</b>',
    extended_stay_success_alert: '<b>1 notte</b> aggiunta al tuo itinerario per <b>{price}</b>',
    extended_stay_error_message:
        'Ci scusiamo, si é verificato un errore. Per parlare con un rappresentante del servizio clienti, chiama il numero 1-800-544-0300',
    extended_stay_note_message: 'Le nuove date di check in e check out saranno',
    check_in: 'Check in',
    check_in_description: 'Date di check-in disponibili in anticipo:',
    check_out: 'Check out',
    check_out_description: 'Date di check-out disponibili in seguito:',
    empty_calendar_before_options: '* Sfortunatamente tutte le date prima del tuo viaggio non sono disponibili.',
    empty_calendar_after_options: '* Purtroppo tutte le date successive al tuo viaggio non sono disponibili.',
    payment_form_add_extended_stay: '{days} Notti Aggiuntive',
    today: 'Oggi',
    clear: 'Chiaro',
    checkout: 'Checkout',
    reset_dates: 'Reimpostare le Date',
    total_cost: 'Costo totale',

    late_check_out_capitalized: 'Aggiungi il check-out posticipato',
    payment_form_add_late_check_out_note: 'Il tuo nuovo orario di check-out sarà',
    payment_form_add_late_check_out: 'Check-out posticipato aggiunto',

    bedroom_title: 'Disposizione dei letti',
    view_all_beds: 'Visualizza tutte le {total} sistemazioni per dormire',
    view_less: 'Mostra meno',
    view_more: 'Mostra di più',

    pool_heat_capitalized: 'Aggiungi climatizzazione della piscina',
};
